import TableList from "../../sub-components/Generic/TableList/TableList.vue";
import ListItem from "../../sub-components/Generic/ListItem/ListItem.vue";
import DateField from "../../common/date-field";
import decimalField from "../../common/decimal-field.vue";

const methods = {
  PaymentInfo(data) {
    return {
      PaymentMethod: data.PaymentMethod,
      PaymentObject: data.PaymentObject
    }
  },
  HttpStatus(data) {
    return data.Status == 200 || data.Status == 202;
  }
}

const fieldNameCPF = [
  { field: "Customer.Name", class: "text-left" },
  { field: "Customer.Identity", type: 'identity', class: "sub-item text-left same-line" }
];

const fieldPayment = [
  { field: "PaymentMethod", type: 'paymentMethodName', class: "text-left" },
  { field: methods.PaymentInfo, type: 'paymentObject', class: "sub-item text-left" }
];

export default {
  name: "MerchantNotification",
  components: {
    TableList,
    DateField,
    ListItem,
    decimalField
  },
  data() {
    return {
      //Main
      countFilter: 0,
      filter: this.FilterDefault(),

      headers: [
        { field: methods.PaymentInfo, label: "", type: "paymentMethodIcon" },
        { field: "Id", label: "Código" },
        { field: fieldNameCPF, label: "Forma de pagamento", classHeader: 'text-left', classField: "text-left" },
        { field: "Reference", label: "Referência", classHeader: 'text-left', classField: "text-left break-line" },
        { field: fieldPayment, label: "Pagamento" },
        { field: "Application", label: "Aplicação", default: "Aplicação não informada" },
        { field: "Amount", label: "Valor", type: "currency", classHeader: 'text-left', classField: "same-line text-left" },
        { field: "Notification.Status", label: "Enviado", type: "YesNoIcon" },
        { field: "PaymentDate", label: "Data de pagamento", type: "dateTime", default: "Não houve pagamento" },
      ],
      itemList: [],
      pagination: this.PaginationDefault(),
      selectedItem: null,

      //Modal
      step: 0,
      itemGet: null,
      headerHist: [
        { field: "TransactionStatus.Name", label: "Status" },
        { field: "ChangedDate", label: "Data Ocorrência", type: "dateTime" }
      ],
      //AT = Attempted Transactions
      headerAT: [
        { field: "NotificationId", label: "Código Notificação", classField: "break-line", default:"-" },
        { field: "TransactionStatus.Name", label: "Status da Transação" },
        { field: methods.HttpStatus, label: "Status", type: "YesNoIcon" },
        { field: "NotificationDate", label: "Data da Notificação", type: "dateTime" },
        { field: "ResponseMessage", label: "Resultado", default:"-"}
      ],
      additionalActionsAT: [
        {name: 'ViewJSON', label: 'Ver JSON', icon:'fas fa-eye mr-2'}
      ],
      itemListAT: [],
      paginationListAT: this.PaginationDefault(),
      payloadObject: null,
      jsonToView: null,
      titleJSON: null,

      //Pre-defined
      modalTitle: "Detalhes",
      pageName: 'Notificações',
      permissionIsAuthorize: 'MerchantNotification',
      styleClass: { th: "less-pd", td: "less-pd" },

      //Is filled and doesn't change
      idMerchant: null,
      paymentMethods: [],
      applications: [],
      transactionStatus: [],

      //Loadings
      loading: false,

      loadingGet: false,
      loadingListAT: false,

      loadingPaymentMethods: false,
      loadingApplications: false,
      loadingTransactionStatus: false,
    };
  },

  mounted() {
    if (this.$route.params.idMerchant !== null && this.$route.params.idMerchant !== undefined) {
      this.idMerchant = this.$route.params.idMerchant;
    }

    this.ListPaymentMethod();
    this.ListApplications();
    this.ListTransactionStatus();

    this.ListTransactionNotification();
  },

  computed: {
    loadingExtras() {
      return this.loadingPaymentMethods && this.loadingApplications && this.loadingTransactionStatus;
    }
  },

  methods: {
    // #region Others
    OpenFieldMain(item, index, eventName) {
      this.step = 0;
      this.selectedItem = item;

      this.GetTransaction();
      this.ListNotifications();

      this.$bvModal.show("mMoreInfo");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListTransactionNotification();
    },

    ResetFilter() {
      this.filter = this.FilterDefault();
      this.ListTransactionNotification();
    },

    PaginationDefault() {
      return {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      }
    },

    FilterDefault() {
      return {
        CreatedDateInitial: null,
        CreatedDateEnd: null,
        PaymentDateInitial: null,
        PaymentDateEnd: null,

        Id: null,
        Reference: null,
        Application: null,
        CustomerName: null,
        CustomerIdentity: null,
        PaymentMethodCode: null,
        TransactionStatusCode: null,
        IsSandbox: null
      }
    },

    SelectJSON(item, index, eventName){
      this.titleJSON = item.NotificationId ? item.NotificationId : 'JSON';
      this.payloadObject = null;
      if (item && item.PayloadObject) {
        this.payloadObject = item.PayloadObject;
        this.jsonToView = this.SyntaxHighlight(JSON.stringify(item.PayloadObject, undefined, 2));
      }
      this.$bvModal.show('mShowJSON')
    },

    CopyJSON(){
      navigator.clipboard.writeText(JSON.stringify(this.payloadObject)).then(
        () => {
          this.$makeToast("Copiado com successo", "success", "Copiado");
        }
      ).catch(
        err => {
          this.$makeToast("Erro ao copiar", "danger", "Erro");
        }
      );
    },

    SyntaxHighlight(json) {
      const regex = /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g;

      json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return json.replace(regex, (match) => {
        let cls = 'number';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key';
          } else {
            cls = 'string';
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
        } else if (/null/.test(match)) {
          cls = 'null';
        }
        return '<span class="' + cls + '">' + match + '</span>';
      });
    },

    // #endregion Others

    // #region Main Request
    ListTransactionNotification() {
      this.itemList = [];
      this.loading = true;
      this.countFilter = 0;
      Object.values(this.filter).map(value => { if (value) this.countFilter++ });
      const params = this.GetParamsListTransactionNotification();
      this.$store.dispatch("ListTransactionNotification", params)
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar. Tente novamente.",
            "danger", "Erro ao listar.", error);
        })
        .finally(() => (this.loading = false));
    },

    GetParamsListTransactionNotification(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Merchant.Id": this.idMerchant,

        "CreatedDateInitial": this.filter.CreatedDateInitial,
        "CreatedDateEnd": this.filter.CreatedDateEnd,
        "PaymentDateInitial": this.filter.PaymentDateInitial,
        "PaymentDateEnd": this.filter.PaymentDateEnd,

        "Object.Id": this.filter.Id,
        "Object.Reference": this.filter.Reference,
        "Object.Application": this.filter.Application,
        "Object.Customer.Name": this.filter.CustomerName,
        "Object.Customer.Identity": this.filter.CustomerIdentity,
        "Object.PaymentMethod.Code": this.filter.PaymentMethodCode,
        "Object.TransactionStatus.Code": this.filter.TransactionStatusCode,
        "Object.IsSandbox": this.filter.IsSandbox
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    // #endregion Main Request
    // #region Get Requests
    GetTransaction() {
      this.itemGet = null;
      this.loadingGet = true;
      this.$store.dispatch("GetTransaction", { Id: this.selectedItem.Id })
        .then(response => {
          this.itemGet = response;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar. Tente novamente.", "danger", "Erro ao listar.", error);
        })
        .finally(() => (this.loadingGet = false));
    },

    ListNotifications() {
      this.itemListAT = [];
      this.loadingListAT = true;
      let params = {
        ...this.paginationListAT,
        "Object.Id": this.selectedItem.Id,
        "Object.Merchant.Id": this.idMerchant
      };
      this.$store.dispatch("ListNotifications", params)
        .then(response => {
          this.itemListAT = response.Objects;
          this.paginationListAT.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar. Tente novamente.", "danger", "Erro ao listar.", error);
        })
        .finally(() => (this.loadingListAT = false));
    },
    // #endregion Get Requests

    // #region Selects fillers
    ListPaymentMethod() {
      this.loadingPaymentMethods = true;
      this.$store
        .dispatch("ListPaymentMethod")
        .then(response => {
          this.paymentMethods = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de tipos de pagamento", error);
        })
        .finally(() => (this.loadingPaymentMethods = false));
    },

    ListApplications() {
      this.loadingApplications = true;
      this.$store
        .dispatch("ListTransactionApplication", { idMerchant: this.idMerchant })
        .then(response => {
          this.applications = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de aplicações", error);
        })
        .finally(() => (this.loadingApplications = false));
    },

    ListTransactionStatus() {
      this.loadingTransactionStatus = true;
      this.$store
        .dispatch("ListTransactionStatus", {})
        .then(response => {
          this.transactionStatus = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro carregar a lista de status", error);
        })
        .finally(() => (this.loadingTransactionStatus = false));
    },

    // #endregion Selects fillers
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/MerchantNotification/MerchantNotification.js